// @systeme: interface
// L'enregistreur : un bouton, un vocal. Utilise ce que le téléphone sait faire (webm/opus
// sur Android et ordinateur, mp4/aac sur iPhone). Ne décide rien : il rend un fichier.
export type EtatEnregistreur = 'inactif' | 'enregistre' | 'indisponible';

const TYPES = [
  'audio/webm;codecs=opus',
  'audio/webm',
  'audio/mp4',
  'audio/ogg;codecs=opus',
  'audio/mpeg',
];

export function enregistrementDisponible(): boolean {
  return (
    typeof navigator !== 'undefined' &&
    Boolean(navigator.mediaDevices?.getUserMedia) &&
    typeof MediaRecorder !== 'undefined'
  );
}

function typeSupporte(): string | undefined {
  if (typeof MediaRecorder === 'undefined') return undefined;
  return TYPES.find((t) => MediaRecorder.isTypeSupported(t));
}

export class Enregistreur {
  private flux: MediaStream | undefined;
  private enregistreur: MediaRecorder | undefined;
  private morceaux: Blob[] = [];

  async demarrer(): Promise<void> {
    this.flux = await navigator.mediaDevices.getUserMedia({
      audio: { echoCancellation: true, noiseSuppression: true },
    });
    const type = typeSupporte();
    this.enregistreur = type
      ? new MediaRecorder(this.flux, { mimeType: type })
      : new MediaRecorder(this.flux);
    this.morceaux = [];
    this.enregistreur.ondataavailable = (e: BlobEvent) => {
      if (e.data.size > 0) this.morceaux.push(e.data);
    };
    this.enregistreur.start(1000);
  }

  /** Arrête et rend le vocal. */
  arreter(): Promise<Blob> {
    return new Promise((resoudre) => {
      const e = this.enregistreur;
      if (!e) {
        resoudre(new Blob([]));
        return;
      }
      e.onstop = () => {
        const type = e.mimeType || 'audio/webm';
        resoudre(new Blob(this.morceaux, { type }));
        this.liberer();
      };
      if (e.state !== 'inactive') e.stop();
      else e.onstop(new Event('stop'));
    });
  }

  annuler(): void {
    if (this.enregistreur && this.enregistreur.state !== 'inactive') {
      this.enregistreur.onstop = null;
      this.enregistreur.stop();
    }
    this.liberer();
  }

  private liberer() {
    this.flux?.getTracks().forEach((piste) => piste.stop());
    this.flux = undefined;
    this.enregistreur = undefined;
  }
}
